<template>
  <div>
    <div id="topup" class="banner">
      <section id="hero" class="d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div style="margin-top: 100px;" class="col-lg-12 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1 hero-title"
                 data-aos="fade-up" data-aos-delay="200">
              <h1 style="line-height:1.2">Most reliable Top-Up solution in Bangladesh</h1>
              <h2>Use Winfin Top-Up solution to stay connected with your friends and family.</h2>
            </div>
            <!--                    <div class="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">-->
            <!--                        <img src="assets/header.png" class="img-fluid animated" alt="">-->
            <!--                    </div>-->
          </div>
          <TopUp/>
        </div>
      </section><!-- End Hero -->
    </div>
    <section class="opt-section">
      <div class="col-12">
        <div class="row operators">
          <div class="col-lg-2 col-sm-6 opt-each">
            <img src="assets/img/operators/all/robi.png" alt="robi">
          </div>
          <div class="col-lg-2 col-sm-6 opt-each">
            <img src="assets/img/operators/all/gp.png" alt="gp">
          </div>
          <div class="col-lg-2 col-sm-6 opt-each">
            <img src="assets/img/operators/all/airtel.png" alt="airtel">
          </div>
          <div class="col-lg-2 col-sm-6 opt-each">
            <img src="assets/img/operators/all/teletalk.png" alt="teletalk">
          </div>
          <div class="col-lg-2 col-sm-6 opt-each">
            <img src="assets/img/operators/all/bl.png" alt="bl">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TopUp from "../components/TopUp"
export default {
  name: 'MainCarousel',
  components: {
    TopUp
  }
}

</script>

<style scoped lang="scss">
.parcel-search {
  border-radius: 5px;
  background: #4f4597;
  //height: 120px;
  //position: absolute;
  padding: 20px;
}

.large-title {
  font-weight: 600;
}

.banner-list {
  list-style: none;
  padding-left: 0;
  font-size: 18px;
  line-height: 40px;
  margin-top: 20px;
}

.banner-list span {
  margin: 5px;
}
.hero-title {
  text-align: center;
  margin-top: 20px;
  h1 {
    color: #FFFFFF;
  }
  h2 {
    color: #FFFFFF;
  }
}
.operators {
  justify-content: center;
  border-bottom: 1px solid rgba(175, 178, 182, 0.45);
  padding-bottom: 35px;
}
.operators img {
  width: 140px;
  height: 50px;
}
section {
  padding: 30px 0 !important;
}
.opt-each {
  text-align: center;
}
@media (max-width: 992px) {
  .operators {
    text-align: center;
  }
  .operators img {
    width: 100%;
    height: 100px;
    padding: 20px 0;
  }
  .opt-each img {
    width: 50%;
  }
  .opt-section {
    display: none;
  }
}
</style>
